import { useCallback, useState } from 'react';

interface UseInstagramPublicationCardProps {
  instagramId: string;
  previewUrl: string | null;
  publishedAtLabel: string | null;
  onToggle: (instagramId: string) => void;
}

export const useInstagramPublicationCard = ({
  instagramId,
  previewUrl,
  publishedAtLabel,
  onToggle,
}: UseInstagramPublicationCardProps) => {
  const [isPreviewBroken, setIsPreviewBroken] = useState(false);

  const previewErrorHandler = useCallback(() => {
    setIsPreviewBroken(true);
  }, []);

  const toggleHandler = useCallback(() => {
    onToggle(instagramId);
  }, [instagramId, onToggle]);

  // Ссылки на карточках одинаковые по тексту — подпись для экранного
  // диктора различает их по дате
  const linkAriaLabel = publishedAtLabel
    ? `Открыть публикацию от ${publishedAtLabel} в Instagram`
    : 'Открыть публикацию в Instagram';

  return {
    isPreviewShown: Boolean(previewUrl) && !isPreviewBroken,
    linkAriaLabel,
    previewErrorHandler,
    toggleHandler,
  };
};
